// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageContainer___hkPIw{padding:16px 40px}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroupDeployed/TenantGroupDeployed.css"],"names":[],"mappings":"AAAA,uBAAA,iBAAA","sourcesContent":[".pageContainer {\n    padding: 16px 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": "pageContainer___hkPIw"
};
export default ___CSS_LOADER_EXPORT___;
